<!-- :render="renderContent" -->
<template>
    <Tree :data="baseData" 
    
    @on-select-change="getNodes"
    ></Tree>
</template>
<script>
    export default {
        data () {
            return {
                baseData: [],
                ctime:{},
                buttonProps: {
                    type: 'ghost',
                    size: 'small',
                },
                first:true 
            }
        },
        watch: {
            'deptData': function (n, o) {
                var len = this.deptData.length;
                if(len !== 0){
                    this.getTree()
                }
            },
            'selectedId': function (n, o) {
                // var len = this.selectedId.length;
                // console.log(this.selectedId)
                if(this.selectedId !== undefined ){
                    if(n[0] !== o[0]){
                        this.getTree()
                        // console.log(this.baseData);
                    }
                }
                
            },
       },
        props:['deptData','selectedId'],
        methods: {
            renderContent (h, { root, node, data }) {
                var vue = this;
                // console.log(node)
                return h('span', {
                    style: {
                        display: 'inline-block',
                        width: '100%'
                    }
                }, [
                    h('span', [
                        h('Icon', {
                            props: {
                                type: 'ios-paper-outline'
                            },
                            style: {
                                marginRight: '8px'
                            }
                        }),
                        h('span',{
                            style: {
                                cursor: 'pointer',
                            },
                            on: {
                                click: () => { 
                                    // console.log(node)
                                    console.log(data)
                                    // console.log(vue.selectedId)
                                    // vue.selectedId = [];
                                    // vue.selectedId.push(data.wproviderId);
                                    // console.log(vue.selectedId)
                                    // this.$emit('getCurrDate',data);

                                    // this.append(data) 
                                }
                            }
                        },data.title)
                    ]),
                    h('span', {
                        style: {
                            display: 'inline-block',
                            float: 'right',
                            marginRight: '32px'
                        }
                    })
                ]);
            },
            append (data) {
                const children = data.children || [];
                children.push({
                    title: 'appended node',
                    expand: true
                });
                this.$set(data, 'children', children);
            },
            remove (root, node, data) {
                const parentKey = root.find(el => el === node).parent;
                const parent = root.find(el => el.nodeKey === parentKey).node;
                const index = parent.children.indexOf(data);
                parent.children.splice(index, 1);
            },
            getTree(){
                // debugger;
                // console.log(this.selectedId)
                // this.deptData = [];
                this.baseData = [];//初始化
                var start = new Date().getTime();//起始时间
                //准备数据
                var data = this.deptData;
                let treedata = [];
                var childList = [];
                var selectedId = this.selectedId;
                // console.log(this.selectedId)
                // console.log(selectedId[0])
                //查找最顶层
                let len = data.length;
                // console.log(len)
                if(len == 0){
                    return;
                }
                
                for(let j=0;j<len;j++){
                    data[j].expand = false;
                    data[j].title = data[j].wproviderName;
                    // console.log(data)
                    // console.log(data[j].id)
                    // console.log(selectedId)
                    if(selectedId.length !== 0 ){

                            if(data[j].id == selectedId[0]){
                                 // console.log(222)
                                treedata.push({
                                    "id":data[j].id,
                                    "expand":true,
                                    "title":data[j].wproviderName, //仓库名称
                                    "wproviderId":data[j].wproviderId, //仓库代码
                                    "children":[],
                                    "selected":true,
                                    "storageAreaList":data[j].storageAreaList,
                                    // render: (h, { root, node, data }) => {

                                    //         // this.$emit('getCurrDate',data);
                                    //         return h('span', {
                                    //             style: {
                                    //                 display: 'inline-block',
                                    //                 width: '100%'
                                    //             }
                                    //             }, [
                                    //             h('span', [
                                    //                 h('Icon', {
                                    //                     props: {
                                    //                         type: 'ios-folder-outline'
                                    //                     },
                                    //                     style: {
                                    //                         marginRight: '8px'
                                    //                     }
                                    //                 }),
                                    //                 h('span',{
                                    //                     // attrs:{
                                    //                     //     class:'curWarehouse',
                                    //                     // },
                                    //                     style: {
                                    //                         cursor: 'pointer',
                                    //                     },
                                    //                     on: {
                                    //                         click: () => { 
                                    //                             // 点击仓库
                                    //                             console.log(node)
                                    //                             this.$attrs.class = 'curWarehouse';
                                    //                             console.log(this)
                                    //                             console.log(this.$attrs)
                                    //                         }
                                    //                     }
                                    //                 } , data.title)
                                    //             ]),
                                    //             h('span', {
                                    //                 style: {
                                    //                     display: 'inline-block',
                                    //                     float: 'right',
                                    //                     marginRight: '32px',

                                    //                 }
                                    //             }, [
                                    //                 h('Button', {
                                    //                     props: Object.assign({}, this.buttonProps, {
                                    //                         icon: 'ios-plus-empty',
                                    //                         type: 'primary'
                                    //                     }),
                                    //                     style: {
                                    //                         width: '22px',
                                    //                         height:'20px',
                                    //                         lineHeight:'15px'
                                    //                     },
                                    //                     on: {
                                    //                         click: () => { 
                                    //                             // 点击+
                                    //                             data.editMsg = true;
                                    //                             this.$emit('addDate',data); 
                                                                
                                    //                         }
                                    //                     }
                                    //                 })
                                    //             ])
                                    //         ]);
                                        
                                    // },
                                })
                                // this.getNodes(treedata)
                            }else{
                                treedata.push({
                                    "id":data[j].id,
                                    "expand":true,
                                    "title":data[j].wproviderName, //仓库名称
                                    "wproviderId":data[j].wproviderId, //仓库代码
                                    "children":[],
                                    "selected":false,
                                    "storageAreaList":data[j].storageAreaList,
                                    // render: (h, { root, node, data }) => {
                                    //         // this.$emit('getCurrDate',data);
                                    //         return h('span', {
                                    //             style: {
                                    //                 display: 'inline-block',
                                    //                 width: '100%'
                                    //             }
                                    //             }, [
                                    //             h('span', [
                                    //                 h('Icon', {
                                    //                     props: {
                                    //                         type: 'ios-folder-outline'
                                    //                     },
                                    //                     style: {
                                    //                         marginRight: '8px'
                                    //                     }
                                    //                 }),
                                    //                 h('span',{
                                    //                     attrs:{
                                    //                         class:'curWarehouse'
                                    //                     },
                                    //                     style: {
                                    //                         cursor: 'pointer',
                                    //                     },
                                    //                     on: {
                                    //                         click: () => { 
                                    //                             // 点击仓库
                                    //                             console.log(node)
                                    //                             this.$attrs.class = 'curWarehouse';

                                    //                             console.log(this)
                                    //                             console.log(this.$attrs)
                                    //                             // console.log(data)
                                    //                             // this.$emit('getCurrDate',data);
                                    //                         }
                                    //                     }
                                    //                 } , data.title)
                                    //             ]),
                                    //             h('span', {
                                    //                 style: {
                                    //                     display: 'inline-block',
                                    //                     float: 'right',
                                    //                     marginRight: '32px',

                                    //                 }
                                    //             }, [
                                    //                 h('Button', {
                                    //                     props: Object.assign({}, this.buttonProps, {
                                    //                         icon: 'ios-plus-empty',
                                    //                         type: 'primary'
                                    //                     }),
                                    //                     style: {
                                    //                         width: '22px',
                                    //                         height:'20px',
                                    //                         lineHeight:'15px'
                                    //                     },
                                    //                     on: {
                                    //                         click: () => { 
                                    //                             // 点击+
                                    //                             data.editMsg = true;
                                    //                             this.$emit('addDate',data); 
                                    //                         }
                                    //                     }
                                    //                 })
                                    //             ])
                                    //         ]);

                                      
                                    // },
                                })
                            }
                    }else{
                        treedata.push({
                            "id":data[j].id,
                            "expand":true,
                            "title":data[j].wproviderName, //仓库名称
                            "wproviderId":data[j].wproviderId, //仓库代码
                            "children":[],
                            "selected":false,
                            "storageAreaList":data[j].storageAreaList,
                            // render: (h, { root, node, data }) => {
                            //                 // this.$emit('getCurrDate',data);
                            //                 return h('span', {
                            //                     style: {
                            //                         display: 'inline-block',
                            //                         width: '100%'
                            //                     }
                            //                     }, [
                            //                     h('span', [
                            //                         h('Icon', {
                            //                             props: {
                            //                                 type: 'ios-folder-outline'
                            //                             },
                            //                             style: {
                            //                                 marginRight: '8px'
                            //                             }
                            //                         }),
                            //                         h('span',{
                            //                             style: {
                            //                                 cursor: 'pointer',
                            //                             },
                            //                             on: {
                            //                                 click: () => { 
                            //                                     // 点击仓库
                            //                                     this.$attrs.class = 'curWarehouse';
                            //                                     console.log(node)
                            //                                     console.log(this)
                            //                                     console.log(this.$attrs)
                            //                                     // console.log(data)
                            //                                     // this.$emit('getCurrDate',data);
                            //                                 }
                            //                             }
                            //                         } , data.title)
                            //                     ]),
                            //                     h('span', {
                            //                         style: {
                            //                             display: 'inline-block',
                            //                             float: 'right',
                            //                             marginRight: '32px',

                            //                         }
                            //                     }, [
                            //                         h('Button', {
                            //                             props: Object.assign({}, this.buttonProps, {
                            //                                 icon: 'ios-plus-empty',
                            //                                 type: 'primary'
                            //                             }),
                            //                             style: {
                            //                                 width: '22px',
                            //                                 height:'20px',
                            //                                 lineHeight:'15px'
                            //                             },
                            //                             on: {
                            //                                 click: () => { 
                            //                                     // 点击+
                            //                                     data.editMsg = true;
                            //                                     this.$emit('addDate',data); 
                            //                                 }
                            //                             }
                            //                         })
                            //                     ])
                            //                 ]);

                                      
                            // },
                        })
                    }
                   
                   
                        
                     
                }
                // console.log(treedata);

               // 展示2级数据
                for(let h=0,ls=treedata.length;h<ls;h++){
                    // console.log(treedata[h])
                    for(let p=0,lq=treedata[h].storageAreaList.length;p<lq;p++){
                        
                        // console.log(treedata[h].storageAreaList[p])
                        // console.log(selectedId)
                        // console.log(selectedId.length)
                        if(selectedId.length == 0 ){
                            selectedId.push(treedata[h].storageAreaList[p].id);
                        };
                        // console.log(selectedId[0])
                        if(treedata[h].storageAreaList[p].id == selectedId[0]){
                            treedata[h].children.push({
                                "id":treedata[h].storageAreaList[p].id,
                                "expand":true,
                                "areaId":treedata[h].storageAreaList[p].areaId,
                                "title":treedata[h].storageAreaList[p].areaName,
                                "defaultIn":treedata[h].storageAreaList[p].defaultIn,
                                "defaultOut":treedata[h].storageAreaList[p].defaultOut,
                                "selected":true
                            })
                            if(this.first == true){
                                // console.log('first')
                                this.getNodes(treedata[h].children)
                                this.first = false;
                            } 
                        }else{
                            treedata[h].children.push({
                                "id":treedata[h].storageAreaList[p].id,
                                "expand":true,
                                "areaId":treedata[h].storageAreaList[p].id,
                                "title":treedata[h].storageAreaList[p].areaName,
                                "defaultIn":treedata[h].storageAreaList[p].defaultIn,
                                "defaultOut":treedata[h].storageAreaList[p].defaultOut,
                                "selected":false
                            })
                        }
                        


                    }
                }

                this.baseData = treedata;
               
                var end = new Date().getTime();//结束时间
                console.log("Tree初始化的时间是"+(end - start)+"ms")//返回函数执行需要时间
            },
            currSelect:function(selected){
                if(selected == true){

                }else{

                }
            },
            getNodes:function(node){
                // console.log(node)
                 var data = {
                    selectedId:node[0].id,
                    node:node
                };
                this.$emit('getCurrDate',data);
                // console.log('node'+node.length)

               
                
                // if(node.length !== 0){
                   
                //     node.forEach(r=>{  
                //         data.wproviderName.push(r.wproviderName)
                //         data.wproviderId.push(r.wproviderId)
                //     }) 
                // }
                // console.log(data)
                // this.$emit('getTree',data);
                // console.log(this.$refs.tree.getCheckedNodes())
                // console.log(this.$refs.tree.getSelectedNodes())
            }
        },
        created:function(){
            this.getTree();
        }
        
    }
</script>
<style>
    .curWarehouse{
       background:#d5e8fc;
       color:#495060;
       border-radius:3px;
       padding:0px 10px;
    }
    .ivu-tree-title{
        width:auto;
        text-align: left;
    }
</style>


// WEBPACK FOOTER //
// warehouseTree.vue?6058c7f0